import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

function defaultOnCloseClickHandler() {
	console.log("Default onCloseClickHandler");
}

export default function ModalHeader({ onCloseClick=defaultOnCloseClickHandler }) {
	return(
		<FontAwesomeIcon icon={faTimes} onClick={onCloseClick} className="close-icon" />
	);
}